import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit {
  @Input() data: any;

  constructor() {}
  ngOnInit(): void {}

  /**
   * -------------------------------------------------------
   * @summary toggleMenu
   * @description  Selecciona tab y cambia estatus active
   * @param {any} data data a mostrar
   * @param {number} index id de la data a mostrar
   * -------------------------------------------------------
   */
  activateItem(data: any, index: number) {
    data.forEach((item) => {
      if (item.id === index) {
        item.active = true;
      } else {
        item.active = false;
      }
    });
  }
}
